module.exports = __webpack_public_path__ + "static/permutation-city-0ddf3b1446492fd1871c8d37a220f797.jpg";